import { useQuery } from '@tanstack/react-query';
import { useDataProvider } from '@/data/provider';
import { queryKeys } from '@/lib/query-keys';

/**
 * Hook to count draft reports
 * @returns Number of draft reports, or undefined while loading
 */
export function useDraftReportsCount(): number | undefined {
  const { reports } = useDataProvider();
  const { data: count } = useQuery({
    queryKey: queryKeys.reports.draftCount(),
    queryFn: async () => {
      try {
        const reportList = await reports.listDetailed();
        return reportList.filter((report) => report.status === 'draft').length;
      } catch (error) {
        console.error('Failed to count draft reports:', error);
        return 0;
      }
    },
    // Refetch every 30 seconds to stay up-to-date
    refetchInterval: 30000,
    staleTime: 30000,
  });

  return count;
}
